'use strict';

export default (store, router) => {
  return (request, next) => {
    // do logout action if 401 is returned
    next(function(response) {
      if (response.status === 401) {
        store.dispatch('auth/logOut');
        router.push({ path: '/login' })
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/interceptors/unauthorizedInterceptor.js